/*
 * Copyright © 2021, CodeVision. All rights reserved.
 *
 * This file was generated by Codevision's stub generator
 */

export enum WorkState {
  QUEUED = 0,
  IN_PROGRESS = 1,
  DONE = 2,
}

export namespace WorkState {
  export function values() {
    return Object.keys(WorkState).filter((type) => isNaN(type as any) && type !== 'values');
  }
}
